/* eslint-disable no-console */
/* eslint-disable import/prefer-default-export */

import { getPriceByCurrency } from "~utils/shopify";

function convertShopifyToGA4Item(shopifyProduct, quantity = 1) {
  return {
    item_name: shopifyProduct.title,
    item_id: shopifyProduct.variants[0].sku,
    price: shopifyProduct.variants[0].price,
    item_category: shopifyProduct?.productType || ``,
    quantity
  };
}

export function googleAnalyticsProductTrigger(event, data) {
  let eventData;

  if (event === `begin_checkout`) {
    const { cart, products } = data;

    if (products?.[0]) {
      const addedVariants = [];
      const items = [];

      products.forEach(product => {
        if (!product?.variants?.[0]) {
          return;
        }

        product.variants.forEach(variant => {
          cart.forEach(cartItem => {
            if (
              variant.id === cartItem.variantId &&
              !addedVariants.includes(variant.id)
            ) {
              addedVariants.push(variant.id);
              items.push(convertShopifyToGA4Item(product, cartItem.quantity));
            }
          });
        });
      });

      eventData = {
        event,
        ecommerce: {
          items
        }
      };
    }
  } else {
    const { product, quantity = 1 } = data;

    if (
      !product?.variants?.[0]?.price ||
      !product?.variants?.[0]?.sku ||
      !product?.variants?.[0]?.title
    ) {
      return;
    }

    eventData = {
      event,
      ecommerce: {
        items: [
          {
            ...convertShopifyToGA4Item(product, quantity)
          }
        ]
      }
    };
  }

  if (eventData) {
    // console.log(eventData);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);
  }
}

const facebookPixelCheckoutTrigger = (event, { cart, products }) => {
  if (!window?.fbq || !products?.[0]) {
    return;
  }

  const cartIds = [];
  const currency = `AUD`;

  let cartTotal = 0;

  cart.forEach(cartItem => {
    products.forEach(productItem => {
      productItem.variants.forEach(productItemVariant => {
        if (productItemVariant.id === cartItem.variantId) {
          cartIds.push(cartItem.variantId);
          cartTotal +=
            getPriceByCurrency(productItemVariant, currency) *
            cartItem.quantity;
        }
      });
    });
  });

  const eventData = {
    content_name: `Checkout`,
    content_category: `snippets`,
    content_ids: cartIds,
    value: cartTotal,
    currency: `AUD`
  };

  // console.log(`eventData: `, eventData);

  window.fbq(`track`, event, eventData);
};

const facebookPixelProductTrigger = (event, { product }) => {
  if (
    !window?.fbq ||
    !product?.variants?.[0]?.id ||
    !product?.variants?.[0]?.price ||
    !product?.variants?.[0]?.title
  ) {
    return;
  }

  let adjustedEvent;

  switch (event) {
    case `add_to_cart`:
      adjustedEvent = `AddToCart`;
      break;

    default:
      adjustedEvent = event;
      break;
  }

  const defaultVariant = product.variants[0];

  const eventData = {
    content_name: product?.title,
    content_category: product?.productType,
    content_ids: [defaultVariant.sku],
    content_type: `product`,
    currency: `AUD`,
    value: defaultVariant.price
  };

  // console.log(eventData);

  window.fbq(`track`, adjustedEvent, eventData);
};

export function trigger(providers, eventType, data) {
  if (
    process.env.NODE_ENV !== `production` ||
    typeof window === `undefined` ||
    !window ||
    !providers?.[0]
  ) {
    return;
  }

  if (typeof providers === `string`) {
    providers = [providers];
  }

  providers.forEach(provider => {
    switch (provider.toLowerCase()) {
      case `ga`:
      case `gtm`:
      case `google`:
        googleAnalyticsProductTrigger(eventType, data);
        break;

      case `fb`:
      case `facebook`:
      case `pixel`:
        if (eventType === `begin_checkout`) {
          facebookPixelCheckoutTrigger(`InitiateCheckout`, data);
        } else {
          facebookPixelProductTrigger(eventType, data);
        }
        break;

      default:
        break;
    }
  });
}
